var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_13513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1356.9 597.416C1408.76 638.203 1446.59 646.186 1458.49 646.186C1470.4 646.186 5614 646.844 5614 646.844L5613.82 1523H587.919H479.097H-2958V606.69C-2958 606.69 450.636 606.031 479.097 606.031C507.559 606.031 544.391 599.17 587.919 564.94C606.335 550.079 656.379 519.341 732.948 539.567C798.266 556.819 809.827 575.474 848.327 579.148C954.683 589.297 1003.31 552.712 1049.22 531.786C1099.07 509.064 1133.23 500.945 1199.62 505.004C1268.75 509.231 1314.51 564.087 1356.9 597.416Z",
    fill: "url(#paint0_linear_458_13513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4194 432H-2524V-177H1122.19H3692V432H1386.69C1287.33 432 1195.89 298.364 1150.1 278.245C1104.31 258.126 1057.89 263.046 1011.87 278.245C971.024 291.736 942.23 306.72 917.84 319.412C890.641 333.566 868.92 344.87 842.072 348.073C737.726 360.525 682.071 313.822 635.504 274.746C619.293 261.143 604.183 248.463 588.504 239.526C522.573 201.946 477.389 188.518 389.574 195.231C298.148 202.223 225.886 267.41 181.554 348.073C135.366 432.109 47.4194 432 47.4194 432Z",
    fill: "#C4DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.96 128C1112.01 128 1100.34 137.734 1097.39 150.766C1094.95 147.54 1091.08 145.449 1086.72 145.449C1084.08 145.449 1081.64 146.217 1079.57 147.525C1076.66 146.196 1073.43 145.449 1070.02 145.449C1057.35 145.449 1047.08 155.697 1047.08 168.339C1047.08 170.954 1033.23 173.466 1034.04 175.81H1208.88C1207.95 174.073 1194.22 172.756 1192.28 172.219C1191.59 165.779 1186.12 160.765 1179.48 160.765C1179.14 160.765 1178.81 160.791 1178.48 160.818C1176.11 152.256 1168.25 145.967 1158.92 145.967C1156.97 145.967 1155.09 146.246 1153.31 146.757C1149.09 135.789 1138.44 128 1125.96 128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.09 185.404C1188.12 183.991 1186.72 183.101 1185.15 183.101C1182.23 183.101 1179.87 186.189 1179.87 190C1179.87 186.189 1177.51 183.101 1174.59 183.101C1173.03 183.101 1171.62 183.989 1170.65 185.399M1175.26 167.008C1174.3 165.594 1172.89 164.706 1171.33 164.706C1168.41 164.706 1166.05 167.794 1166.05 171.604C1166.05 167.794 1163.68 164.706 1160.76 164.706C1159.2 164.706 1157.79 165.594 1156.83 167.004",
    stroke: "#0068A9",
    strokeWidth: 1.512,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.621 79.9999C186.307 79.9999 193.571 86.0603 195.408 94.1732C196.93 92.1653 199.336 90.8633 202.053 90.8633C203.692 90.8633 205.216 91.3416 206.505 92.1558C208.315 91.328 210.327 90.8633 212.449 90.8633C220.337 90.8633 226.732 97.2434 226.732 105.114C226.732 106.742 235.354 108.306 234.85 109.765H126C126.577 108.684 135.123 107.864 136.329 107.53C136.764 103.521 140.165 100.399 144.299 100.399C144.51 100.399 144.718 100.415 144.926 100.431C146.402 95.1013 151.292 91.1857 157.103 91.1857C158.313 91.1857 159.484 91.3592 160.592 91.6776C163.221 84.849 169.851 79.9999 177.621 79.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.761 81.8676C191.461 81.8676 187.865 84.9099 186.956 88.9826C186.202 87.9746 185.011 87.321 183.666 87.321C182.854 87.321 182.1 87.5611 181.462 87.9698C180.566 87.5543 179.57 87.321 178.519 87.321C174.614 87.321 171.448 90.5237 171.448 94.4747C171.448 95.2922 175.69 96.0771 175.939 96.8096H213.415C213.415 96.8096 216.801 95.8553 216.204 95.6873C215.989 93.6748 214.305 92.1078 212.258 92.1078C212.153 92.1078 212.051 92.1159 211.948 92.1241C211.217 89.4484 208.796 87.4828 205.919 87.4828C205.32 87.4828 204.741 87.5699 204.192 87.7297C202.891 84.3018 199.608 81.8676 195.761 81.8676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_13513",
    x1: 1923.81,
    y1: 1484.82,
    x2: 1000.14,
    y2: 2406.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121921,
    stopColor: "#6ABC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#23A2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998455,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998569,
    stopColor: "#0095D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_13513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img-1.8da5d3c1d1c03e5c47d9e99421eb44f1.svg";
export { ForwardRef as ReactComponent };